import { Stack, Typography } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import React, { useEffect, useState, useRef, useMemo } from "react";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import "./CourseMasterData.css";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { getCourseMasterData } from "../app/DeliveryLeadershipSlice";
import AddMorePopup from "./AddMorePopup";
// import EditPopup from "./EditPopup";
import Button from "@mui/material/Button";
import { uploadMasterData } from "../app/DeliveryLeadershipSlice";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { CSVLink } from "react-csv";
import { IoMdDownload } from "react-icons/io";

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
  },
});
const columns = [
  { id: "sno", label: "SL.#", align: "center" },
  {
    id: "courseCode",
    label: "Course Code",
    align: "center",
  },
  {
    id: "courseName",
    label: "Course Name",
    align: "center",
  },
  {
    id: "duration",
    label: "Course Hours",
    align: "center",
  },
  {
    id: "audienceLevel",
    label: "Audience Level",
    align: "center",
  },
  {
    id: "programOwner",
    label: "Program Owner",
    align: "center",
  },
];
function CourseMasterData() {
  const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });

  const searchFunction = (e) => {
    setSearchVal(e.target.value);
    setPage(0);
  };

  const courseData = useSelector(
    (state) => state.deliveryLeadership.courseMasterData
  );

  const uploadStatus =
    useSelector((state) => state?.deliveryLeadership?.isUploaded) ?? false;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [islogFetchAlert, setIslogFetchAlert] = useState(false);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [islogDataFetched, setlogDataIsFetched] = useState(false);
  const [severity, setSeverity] = useState(null);
  const dispatch = useDispatch();
  const [openAddMore, setOpenAddMore] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [smeName, setSmeName] = useState();
  const [courseCode, setcourseCode] = useState();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [uploadStatusMsg, setUploadStatusMsg] = useState("");
  const { isLoaded, isDataSentSuccess, isDataSentFailure } =
    useSelector((state) => state.deliveryLeadership) ?? false;
  const responseMsg =
    useSelector((state) => state.deliveryLeadership.masterResponseMessage) ?? false;

const [searchVal, setSearchVal] = useState("");    
const filteredData = useMemo(() => {
  const query = searchVal.trim().toLowerCase();
  if (!query) return courseData;

  return courseData.filter(({ courseName = "" }) =>
    courseName.toLowerCase().includes(query)
  );
}, [courseData, searchVal]);

  const handleEditOpen = (smeID, courseCode) => {
    setOpenEdit(true);
    setSmeName(smeID);
    setcourseCode(courseCode);
  };
  useEffect(() => {
    if (isFileUploaded) {
      if (isLoaded) {
        setSeverity("warning");
        setUploadStatusMsg("File uploading...Please wait!");
      } else if (isDataSentSuccess) {
        setSeverity("success");
        setUploadStatusMsg("File Uploaded Successfully.!");
      } else {
        setSeverity("error");
        setUploadStatusMsg(responseMsg || "Error in uploading the File!");
      }
    }
  }, [isLoaded, isDataSentSuccess, isDataSentFailure]);
  const headers = [
    { label: "Course Code", key: "courseCode" },
    { label: "Course Name", key: "courseName" },
    { label: "Duration", key: "duration" },
     { label: "Audience Level", key: "audienceLevel" },
    { label: "Program Owner", key: "programOwner" },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  useEffect(() => {
    dispatch(getCourseMasterData());
  }, []);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const ref = useRef();
  const saveFile = (e) => {
    setFile(e.target.files[0]);
  };
  const handleUpload = () => {
    const formData = new FormData();
    formData.append("file", file);
    setIsFileUploaded(true);
    dispatch(uploadMasterData(formData))
    setFile(null);
  };
  const handleSampleCourseDownload = async () => {
    try {
      let fileUrl = process.env.PUBLIC_URL + "/template/sample_courses_DL.xlsx";
      let fileName = `sample_courses_DL.xlsx`;
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${fileName}`;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Stack sx={{ marginTop: "0px" }}>
          <Stack>
            {/* <Typography sx={{ fontSize: "18px", fontWeight: "600", marginBottom: "12px" }}>
       Course Master Data
      </Typography> */}
            <h3 className="upload_section_header">Course Master Data</h3>
            {/* <Typography sx={{ fontSize: "14px", marginBottom: "20px" }}>
       This section lists the courses that are offered by L&TT. You as Admin can Add new
       courses, change the SME for a particular course.
      </Typography> */}
            <p className="upload_section_para">
              This section lists the courses that are offered by L&TT. You as
              Admin can Add new courses, change the Approver for a particular
              course.
            </p>
          </Stack>
          <div className="course-actions-header">
            <div className="download_section">
              <div className="training-courses-download">
                <CSVLink
                  data={courseData}
                  headers={headers}
                  filename={"course_master_DL.csv"}
                  target="_blank"
                  className="training-courses-download-btn"
                >
                  Courses Master{" "}
                  <IoMdDownload
                    style={{
                      "verticalAlign": "text-bottom",
                      marginLeft: "2px",
                    }}
                  />
                </CSVLink>
              </div>
              <button
                className="course_master__sample_file_download"
                onClick={handleSampleCourseDownload}
                style={{ padding: "6px 15px" }}
              >
                <span>
                  Download Sample{" "}
                  <IoMdDownload
                    style={{
                      "verticalAlign": "text-bottom",
                      marginLeft: "2px",
                    }}
                  />
                </span>
              </button>
            </div>
            <Stack
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "end",
              }}
            >
              <Stack spacing={2} direction={"row"} alignItems={"center"}>
                <input
                  type="file"
                  accept=".xlsx"
                  ref={ref}
                  id="file"
                  onChange={saveFile}
                  hidden
                />
                <label className="th-mainData" htmlFor="file">
                  Select File
                </label>
                <span className="th-file_caption">
                  {file ? file.name : "No File Selected"}
                </span>
                <Button
                  className={
                    loading === false
                      ? "th-upload_button_modal_active"
                      : "th-upload_button_modal_inactive"
                  }
                  onClick={handleUpload}
                  sx={{ marginTop: "10px", marginLeft: "20px" }}
                >
                  {loading === false ? "Upload" : "Cancel"}
                </Button>
                {isFileUploaded && severity && (
                  <Alert
                    className="file-status"
                    severity={severity}
                    onClose={() => setIsFileUploaded(false)}
                  >
                    {uploadStatusMsg}
                  </Alert>
                )}
              </Stack>
            </Stack>
          </div>
          <Box
            justifyContent={"center"}
            className="text-filed-box"
            display="flex"
            alignItems={"center"}
          >
            <CssTextField
              placeholder="Search for help by course name"
              id="outlined-start-adornment"
              sx={{ m: 1, width: "30ch", align: "center" }}
              value={searchVal}
              onChange={searchFunction}
              size="small"
              margin="dense"
              InputProps={{
                endAdornment: (
                  <IconButton
                    type="submit"
                    sx={{ p: "10px" }}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                ),
              }}
            />
          </Box>
          <Paper sx={{ width: "100%", marginTop: "10px" }}>
            <TableContainer
              sx={{ maxHeight: 440 }}
              className="courseMasterTable"
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{
                          top: 0,
                          minWidth: column.minWidth,
                          color: "#fff",
                          backgroundColor: "#550A69",
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {loadingSpinner ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "10px",
                    }}
                  >
                    <CircularProgress color="secondary" centered />
                  </Box>
                ) : (
                  <TableBody>
                    {filteredData != undefined &&
                      filteredData.length != 0 &&
                      filteredData
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((item, index) => (
                          <TableRow key={index}>
                            <TableCell align="center" scope="row">
                              {item.sno}
                            </TableCell>
                            <TableCell align="center">
                              {item.courseCode}
                            </TableCell>
                            <TableCell align="center">
                              {item.courseName}
                            </TableCell>
                            <TableCell align="center">
                              {item.duration}
                            </TableCell>
                            <TableCell align="center">
                              {item.audienceLevel || "N/A"}
                            </TableCell>
                            <TableCell align="center">
                              {item.programOwner || "N/A"}
                            </TableCell>
                            {/* <TableCell */}
                            {/*   align="center" */}
                            {/*   onClick={() => { */}
                            {/*     handleEditOpen(item.SMEId, item.courseCode); */}
                            {/*   }} */}
                            {/*   sx={{ cursor: "pointer" }} */}
                            {/* > */}
                            {/*   <img */}
                            {/*     src="/images/Home/edit-icon.png" */}
                            {/*     style={{ width: "20px", height: "20px" }} */}
                            {/*   ></img> */}
                            {/* </TableCell> */}
                          </TableRow>
                        ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              className="courseMasterTable_pagination"
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={
                filteredData && filteredData.length > 0
                  ? filteredData.length
                  : 0
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
          <Stack sx={{ width: "100%", justifyContent: "flex-end" }}>
            <Stack
              direction={"row"}
              spacing={1}
              onClick={() => {
                setOpenAddMore(true);
              }}
              sx={{
                marginTop: "20px",
                width: "100%",
                justifyContent: "flex-end",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <img
                src="/images/Home/plussign.png"
                style={{ width: "15px", height: "15px" }}
              ></img>
              <Typography
                sx={{ color: "#0F4CF1", fontSize: "16px", fontWeight: "600" }}
              >
                Add new course
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <AddMorePopup
          openAddMore={openAddMore}
          setOpenAddMore={setOpenAddMore}
          isDataSentSuccess={isDataSentSuccess}
          setSeverity={setSeverity}
          setUploadStatusMsg={setUploadStatusMsg}
        />
      </ThemeProvider>
    </>
  );
}

export default CourseMasterData;
